import { render, staticRenderFns } from "./CustomColorPicker.vue?vue&type=template&id=408017db"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"
import style0 from "./CustomColorPicker.vue?vue&type=style&index=0&id=408017db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports